import ArticleCard from '@/components/feature/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  const featuredArticles = getFeaturedArticles().slice(0, 3);

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              编辑团队精心挑选的高质量里番动漫内容
            </p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1 text-sm text-accent-600 font-medium">
            <i className="ri-star-fill"></i>
            编辑精选
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article, index) => (
            <div key={article.id} className={index === 0 ? 'md:col-span-2 lg:col-span-1' : ''}>
              <ArticleCard
                article={article}
                variant={index === 0 ? 'featured' : 'default'}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}